import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import _ from 'lodash';

import Grid from '@mui/material/Unstable_Grid2/Grid2';
import Typography from '@mui/material/Typography';

import { handleApiRequest } from '../../api';

import useApiError from '../../hook/useApiError';

import { formatDate2 } from '../../utils/date';

import { CHART_TYPE } from '../../components/chart/constants';
import PieChart from '../../components/chart/PieChart';
import TreeMap from '../../components/chart/TreeMap';
import LineChart from '../../components/chart/LineChart';
import WordCloudD3 from '../../components/chart/WordCloudD3';
import Proccess from '../../components/loading/Proccess';
import NoData from '../../components/nodata/NoData';

import { REPORT_TYPE } from './constants';
import { CardStyle } from './frontPageStyle';


const MainReport = ({ userQuery, dateRange }) => {
  const { handleApiErrorStatus } = useApiError();
  const [proccess, setProccess] = useState({});
  const [reportData, setReportData] = useState({});
  const [asRatio, setAsRatio] = useState(false);

  const filterCondition = new URLSearchParams({
    start_date: dateRange.startDate ? formatDate2(dateRange.startDate) : '',
    end_date: dateRange.endDate ? formatDate2(dateRange.endDate) : '',
    min_user_level: userQuery[0] / 100,
    max_user_level: userQuery[1] / 100,
  })

  const filterConditionRatio = new URLSearchParams({
    start_date: dateRange.startDate ? formatDate2(dateRange.startDate) : '',
    end_date: dateRange.endDate ? formatDate2(dateRange.endDate) : '',
    min_user_level: userQuery[0] / 100,
    max_user_level: userQuery[1] / 100,
    as_ratio: asRatio
  })

  const getQuestionProductTypes = () => {
    setProccess(prev => ({ ...prev, [REPORT_TYPE.question_product_types.id]: true }));
    const params =
      handleApiRequest('getQuestionProductTypes', filterConditionRatio)
        .then(res => {
          if (res.status === 200) {
            setReportData(prev => ({ ...prev, [REPORT_TYPE.question_product_types.id]: res.data.result }));
          } else {
            handleApiErrorStatus(res);
          }
          setProccess(prev => ({ ...prev, [REPORT_TYPE.question_product_types.id]: false }));
        })
  }

  const getEngagedButtonTypes = () => {
    setProccess(prev => ({ ...prev, [REPORT_TYPE.engaged_button_types.id]: true }));
    handleApiRequest('getEngagedButtonTypes', filterConditionRatio)
      .then(res => {
        if (res.status === 200) {
          setReportData(prev => ({ ...prev, [REPORT_TYPE.engaged_button_types.id]: res.data.result }));
        } else {
          handleApiErrorStatus(res);
        }
        setProccess(prev => ({ ...prev, [REPORT_TYPE.engaged_button_types.id]: false }));
      })
  }

  const getPopularQuestionProducts = () => {
    setProccess(prev => ({ ...prev, [REPORT_TYPE.popular_question_products.id]: true }));
    handleApiRequest('getPopularQuestionProducts', filterCondition)
      .then(res => {
        if (res.status === 200) {
          setReportData(prev => ({ ...prev, [REPORT_TYPE.popular_question_products.id]: res.data.result }));
        } else {
          handleApiErrorStatus(res);
        }

        setTimeout(() => {
          setProccess(prev => ({ ...prev, [REPORT_TYPE.popular_question_products.id]: false }));
        }, 500)
      })
  }

  const getGeneratedPruchaseUrls = () => {
    setProccess(prev => ({ ...prev, [REPORT_TYPE.generated_pruchase_urls.id]: true }));
    handleApiRequest('getGeneratedPruchaseUrls', filterCondition)
      .then(res => {
        if (res.status === 200) {
          setReportData(prev => ({ ...prev, [REPORT_TYPE.generated_pruchase_urls.id]: res.data.result }));
        } else {
          handleApiErrorStatus(res);
        }
        setProccess(prev => ({ ...prev, [REPORT_TYPE.generated_pruchase_urls.id]: false }));
      })
  }

  const getUserQuestions = () => {
    setProccess(prev => ({ ...prev, [REPORT_TYPE.user_questions.id]: true }));
    handleApiRequest('getUserQuestions', filterCondition)
      .then(res => {
        if (res.status === 200) {
          setReportData(prev => ({ ...prev, [REPORT_TYPE.user_questions.id]: res.data.result }));
        } else {
          handleApiErrorStatus(res);
        }
        setProccess(prev => ({ ...prev, [REPORT_TYPE.user_questions.id]: false }));
      })
  }

  useEffect(() => {
    getQuestionProductTypes();
    getEngagedButtonTypes();
    getPopularQuestionProducts();
    getGeneratedPruchaseUrls();
    getUserQuestions();
  }, [userQuery, dateRange])

  const isEmptyObject = (obj) => {
    if (obj === undefined || obj === null) {
      return true;
    }

    if (typeof obj !== 'object') {
      return false;
    }
    return Object.keys(obj).length === 0;
  }

  // console.log('reportData', reportData);

  return (
    <>
      <Grid container spacing={2} mt={1}>
        <Grid xs={12} md={6} lg={4}>
          <CardStyle size="medium">
            <Typography variant='h5' mb={1}>{REPORT_TYPE.question_product_types.name}</Typography>
            {
              proccess[REPORT_TYPE.question_product_types.id] &&
              <Proccess size="medium" />
            }
            {
              !proccess[REPORT_TYPE.question_product_types.id] &&
              !isEmptyObject(reportData[REPORT_TYPE.question_product_types.id]) &&
              <PieChart
                chartType={CHART_TYPE.CUSTOM_LABEL_PIE_CHART}
                chartData={reportData[REPORT_TYPE.question_product_types.id]}
              />
            }
            {
              !proccess[REPORT_TYPE.question_product_types.id] &&
              isEmptyObject(reportData[REPORT_TYPE.question_product_types.id]) &&
              <NoData size="medium" type="pieChart" />
            }
          </CardStyle>
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <CardStyle size="medium">
            <Typography variant='h5' mb={1}>{REPORT_TYPE.engaged_button_types.name}</Typography>
            {
              proccess[REPORT_TYPE.engaged_button_types.id] &&
              <Proccess size="medium" />
            }
            {
              !proccess[REPORT_TYPE.engaged_button_types.id] &&
              !isEmptyObject(reportData[REPORT_TYPE.engaged_button_types.id]) &&
              <TreeMap
                chartType={CHART_TYPE.TREE_MAP_CUSTOM}
                chartData={reportData[REPORT_TYPE.engaged_button_types.id]}
              />
            }
            {
              !proccess[REPORT_TYPE.engaged_button_types.id] &&
              isEmptyObject(reportData[REPORT_TYPE.engaged_button_types.id]) &&
              <NoData size="medium" type="tableChart" />
            }
          </CardStyle>
        </Grid>

        <Grid xs={12} md={6} lg={4}>
          <CardStyle size="medium">
            <Typography variant='h5' mb={1}>{REPORT_TYPE.popular_question_products.name}</Typography>
            {
              proccess[REPORT_TYPE.popular_question_products.id] &&
              <Proccess size="medium" />
            }
            {
              !proccess[REPORT_TYPE.popular_question_products.id] &&
              !isEmptyObject(reportData[REPORT_TYPE.popular_question_products.id]) &&
              <WordCloudD3 chartData={reportData[REPORT_TYPE.popular_question_products.id]} />
            }
            {
              !proccess[REPORT_TYPE.popular_question_products.id] &&
              isEmptyObject(reportData[REPORT_TYPE.popular_question_products.id]) &&
              <NoData size="medium" type="cloud" />
            }
          </CardStyle>
        </Grid>

        <Grid xs={12} md={6}>
          <CardStyle size="large">
            <Typography variant='h5'>{REPORT_TYPE.generated_pruchase_urls.name}</Typography>
            {
              proccess[REPORT_TYPE.generated_pruchase_urls.id] &&
              <Proccess size="large" />
            }
            {
              !proccess[REPORT_TYPE.generated_pruchase_urls.id] &&
              !isEmptyObject(reportData[REPORT_TYPE.generated_pruchase_urls.id]) &&
              <LineChart
                chartType={CHART_TYPE.LINE_CHART_SIMPLE}
                chartData={reportData[REPORT_TYPE.generated_pruchase_urls.id]}
                reportType={REPORT_TYPE.generated_pruchase_urls.id}
              />}
            {
              !proccess[REPORT_TYPE.generated_pruchase_urls.id] &&
              isEmptyObject(reportData[REPORT_TYPE.generated_pruchase_urls.id]) &&
              <NoData size="large" type="showChart" />
            }
          </CardStyle>
        </Grid>

        <Grid xs={12} md={6}>
          <CardStyle size="large">
            <Typography variant='h5'>{REPORT_TYPE.user_questions.name}</Typography>
            {
              proccess[REPORT_TYPE.user_questions.id] &&
              <Proccess size="large" />
            }
            {
              !proccess[REPORT_TYPE.user_questions.id] &&
              !isEmptyObject(reportData[REPORT_TYPE.user_questions.id]) &&
              <LineChart
                chartType={CHART_TYPE.LINE_CHART_SIMPLE}
                chartData={reportData[REPORT_TYPE.user_questions.id]}
                reportType={REPORT_TYPE.user_questions.id}
              />
            }
            {
              !proccess[REPORT_TYPE.user_questions.id] &&
              isEmptyObject(reportData[REPORT_TYPE.user_questions.id]) &&
              <NoData size="large" type="showChart" />
            }
          </CardStyle>
        </Grid>
      </Grid>
    </>
  )
}

export default MainReport;